<template>
  <div>
    <BaseShowMore collapsable>
      <template v-if="placements.length">
        <div v-for="placement in placements" :key="placement.hireId" class="tw-mb-7">
          <div class="tw-flex tw-justify-between tw-items-start tw-gap-3">
            <ProfileInfoCard :global-id="placement.companyId">
              <WdsAvatar :path="getAvatarPath(placement.companyPicture, placement.companyId)" />
            </ProfileInfoCard>

            <div class="tw-flex tw-flex-col tw-gap-0 tw-grow-0">
              <a :href="placement.jobUrl">
                {{ placement.jobName }}
              </a>
              <div>
                {{ placement.companyName }}
              </div>
            </div>

            <div class="tw-flex tw-justify-end tw-grow tw-whitespace-nowrap">
              <ButtonSplit
                v-if="placement.latestContractIsDraft && placement.viewerCanAcceptContract"
                v-cloak
                size="xs"
                placement="bottom-end"
              >
                <template #default>
                  <a :href="placement.latestContractAcceptUrl">
                    {{ $t('Accept Contract') }}
                  </a>
                </template>

                <template #dropdown>
                  <ButtonSplitList>
                    <li>
                      <a :href="placement.latestContractPdfUrl" target="_blank">
                        {{ $t('View contract') }}
                      </a>
                    </li>
                  </ButtonSplitList>
                </template>
              </ButtonSplit>

              <a
                v-else-if="placement.conversationId && placement.conversationUrl"
                data-toggle="tooltip"
                :title="$t('Go to conversation')"
                :href="placement.conversationUrl"
              >
                <WdsButtonGhost>
                  <WdsIcon name="chat" :size="16" />
                </WdsButtonGhost>
              </a>
            </div>
          </div>
        </div>
      </template>
      <em v-else>
        {{ $t('Here you will be able to see all of your placements.') }}
      </em>
    </BaseShowMore>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'
import { WdsAvatar, WdsButtonGhost, WdsIcon } from '@worksome/wds-components'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import BaseShowMore from '@/components/BaseShowMore.vue'
import ButtonSplit from '@/components/ButtonSplit.vue'
import ButtonSplitList from '@/components/ButtonSplitList.vue'
import ProfileInfoCard from '@/components/ProfileInfoCard.vue'
import { getAvatarPath } from '@/utils/avatar'

interface Placement {
  hireId: string

  jobName: string
  jobUrl: string

  companyId: string
  companyName: string
  companyPicture?: string

  conversationId?: string
  conversationUrl?: string

  latestContractId: string
  latestContractIsDraft: boolean
  latestContractAcceptUrl: string
  latestContractPdfUrl: string

  viewerCanAcceptContract: boolean
}

defineProps({
  placements: {
    type: Array<Placement>,
    default: () => [],
  },
})
</script>
